

// src/SuccessToast.tsx
import React from 'react';
import { Snackbar, Paper, Typography, IconButton, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

// IMPORTANT: Replace this with the actual path to your green success logo image
// For example, if it's in public/icons/your-success-icon.png
const customSuccessIconPath = process.env.PUBLIC_URL + '/icons/add_tenant_success_msg.svg';

interface SuccessToastProps {
  open: boolean;
  message: string;
  onClose: () => void;
  // The 'severity' prop is removed as this component is now specifically styled for the success look.
  // If you need error/warning toasts with different styles, you might create separate components
  // or a more complex one that handles different appearances.
}

const SuccessToast: React.FC<SuccessToastProps> = ({
  open,
  message,
  onClose,
}) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={1500} // Adjust as needed
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      sx={{
        zIndex: 1400, // Ensure toast is above other elements like dialogs
        mt: 7.5, // Changed from 10 to 5 to move it higher up
      }}
    >
      <Paper
        // elevation={6} // Controls the shadow, adjust as needed
        sx={{
          display: 'flex',
          alignItems: 'center',
          pl: 1.5, // Padding left
          pr: 1,   // Padding right (IconButton has its own padding)
          py: 1,   // Padding top/bottom
          borderRadius: '30px', // Highly rounded corners like the screenshot
          backgroundColor: 'common.white', // White background
          minWidth: '280px', // Minimum width
          maxWidth: '100%',   // Max width relative to screen
          // filter: 'drop-shadow(0px 2px 6px rgba(0,0,0,0.1))', // Softer shadow if elevation is too strong
        }}
      >
        {/* Custom Icon Image */}
        <Box
          component="img"
          src={customSuccessIconPath} // Use your custom image path here
          alt="Success"
          sx={{
            width: 33, // Adjust to your icon's desired size
            height: 33,
            mr: 1,   // Margin right for spacing from text
          }}
        />

        {/* Message Text */}
        <Typography
          variant="body1" // Or 'subtitle1' if you prefer slightly larger/bolder
          sx={{
            flexGrow: 1,
            color: 'text.primary', // Default dark text color
            fontWeight: 500,       // Medium font weight as it appears in screenshot
            fontSize: '14px',   // Adjust font size
          }}
        >
          {message}
        </Typography>

        {/* Close Button */}
        <IconButton
          aria-label="close"
          color="inherit"
          size="small"
          onClick={onClose}
          sx={{
            color: 'text.secondary', // Makes the 'x' a bit lighter
            ml: 1, // Margin left for spacing from text
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Paper>
    </Snackbar>
  );
};

export default SuccessToast;